export enum AgreementTypeEnum {
  SERVE = 1, // 服务协议
  AUTH = 2, // 授权协议
  /** 独立app 登录协议 */
  APP = 3,
  /** 营销落地页-查看协议列表 */
  MARKET = 5,
  /** 哈臻快-a面协议列表 */
  RECHARGE = 6,
}
